export { default } from '../../_slug/_id/index.vue';
